import React from 'react'
import { Button, Checkbox } from '@mobiscroll/react-latest'
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input'
import { ClipLoader } from 'react-spinners'
import classNames from 'classnames'
import Label from '../common/Label'
import { IFormValues, IInputData } from './Login'
import { RIDER_PORTAL_UI_MESSAGES } from 'src/constants/rider-portal'

interface IMainFormProps {
  allowLogin: boolean
  formValues: IFormValues
  loading: boolean
  handleInputChange: (e: IInputData) => void
  handlePhoneNumberChange: (value: string) => void
  handleSelectOtpRecipient: (recipient: 'sms' | 'email') => void
  handleSendOtp: () => void
}

const MainForm = ({
  allowLogin,
  formValues,
  loading,
  handleInputChange,
  handlePhoneNumberChange,
  handleSelectOtpRecipient,
  handleSendOtp
}: IMainFormProps) => {
  const {
    common: { email, phoneNumber: phoneNumberLabel, sms },
    auth: { invalidPhoneNumber, rememberMe, otpRecipient: otpRecipientLabel, sendOTP }
  } = RIDER_PORTAL_UI_MESSAGES
  const {
    otpRecipient,
    persistLogin,
    phoneNumber: { completePhoneNumber }
  } = formValues

  const EVENT_STYLE = !allowLogin ? 'pointer-events-none opacity04' : 'pointer-events-auto opacity1'
  const OPTION_STYLE = {
    selected: 'bg-green1 font-white',
    notSelected: 'bg-light-grey2 font-grey8'
  }

  return (
    <>
      <div className='mb2 mt1 w100'>
        <Label htmlFor={phoneNumberLabel} text={phoneNumberLabel} />
        <div className='mt1'>
          <PhoneInput
            className={classNames('rider-portal-phone-input', {
              'rider-portal-input-error': !!completePhoneNumber && !isValidPhoneNumber(completePhoneNumber),
              'pointer-events-none opacity04': !allowLogin
            })}
            name='phoneNumber'
            placeholder='(555) 123-4567'
            defaultCountry='US'
            value={completePhoneNumber}
            withCountryCallingCode={true}
            onChange={(value: string) => handlePhoneNumberChange(value)}
          />
          <div className='relative'>
            {!!completePhoneNumber && !isValidPhoneNumber(completePhoneNumber) && (
              <div className='absolute font-red fs-12 mbsc-align-right right-0 pt1 top-0'>{invalidPhoneNumber}</div>
            )}
          </div>
        </div>
      </div>
      <div className='mb2 pt2 w100'>
        <Label htmlFor={otpRecipientLabel} text={otpRecipientLabel} />
        <div className={`otp-options flex justify-between mt1 ${EVENT_STYLE}`}>
          <div
            aria-pressed={otpRecipient === 'sms'}
            className={`text-sm weight-500 sms-option ${
              otpRecipient === 'sms' ? OPTION_STYLE.selected : OPTION_STYLE.notSelected
            }`}
            role='button'
            tabIndex={0}
            onClick={() => handleSelectOtpRecipient('sms')}
            onKeyDown={(e: React.KeyboardEvent<HTMLDivElement>) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault()
                handleSelectOtpRecipient('sms')
              }
            }}
          >
            {sms}
          </div>
          <div
            aria-pressed={otpRecipient === 'email'}
            className={`text-sm weight-500 email-option ${
              otpRecipient === 'email' ? OPTION_STYLE.selected : OPTION_STYLE.notSelected
            }`}
            role='button'
            tabIndex={0}
            onClick={() => handleSelectOtpRecipient('email')}
            onKeyDown={(e: React.KeyboardEvent<HTMLDivElement>) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault()
                handleSelectOtpRecipient('email')
              }
            }}
          >
            {email}
          </div>
        </div>
      </div>
      <div className='mb2 pt2 w100'>
        <div className='flex'>
          <Checkbox
            checked={persistLogin}
            id='persistLogin'
            disabled={!allowLogin}
            name='persistLogin'
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              handleInputChange({ name: 'persistLogin', value: e.target.checked })
            }
          />
          <label className='font-grey7 text-sm' htmlFor='persistLogin'>
            {rememberMe}
          </label>
        </div>
      </div>
      <div className='pt2 w100'>
        <Button
          ariaLabel={sendOTP}
          disabled={!allowLogin || loading || !isValidPhoneNumber(completePhoneNumber)}
          className='mbsc-rider-portal-success-btn w100'
          onClick={handleSendOtp}
        >
          {!loading ? sendOTP : <ClipLoader size={24} sizeUnit={'px'} color={'#405264'} loading={loading} />}
        </Button>
      </div>
    </>
  )
}

export default MainForm



// WEBPACK FOOTER //
// ./src/components/riders/rider-portal/authentication/MainForm.tsx